import {Response, UserDetail} from "@core/model";
import {ApiBuilder} from "..";

const fetchUserDetail = (builder: ApiBuilder) =>
  builder.query<UserDetail, string>({
    query: userId => ({
      url: `/api/user/detail/${userId}`,
      method: "GET",
    }),
    transformResponse: (response: Response<UserDetail>) => response.data,
    providesTags: (result, _err, userId) =>
      result ? [{type: "user", id: `detail-${userId}`}] : [],
  });

export {fetchUserDetail};
